import { render } from "./StatusMessage.vue?vue&type=template&id=648eef99"
import script from "./StatusMessage.vue?vue&type=script&lang=js"
export * from "./StatusMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__